import { Component } from 'react';
import * as React from 'react';

import { CollapsibleForm, DietaryNeeds } from '@hungryroot/app-mhr';
import { capitalize } from '../utils/utils';
import TagsSections from './TagsSections';

class FoodProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dietaryPrefsText: '',
      dietaryPreferencesFormVisible: false,
    };
    this.createDisplayedText = this.createDisplayedText.bind(this);
  }

  createDisplayedText(prefs, options, stateKey) {
    let text = prefs.reduce((acc, pref, idx) => {
      let preference = capitalize(options[pref]['optionText']);
      if (idx === 0) {
        acc += preference;
      } else {
        acc += ', ' + preference;
      }
      return acc;
    }, '');
    this.setState({ [stateKey]: text });
  }

  toggleForm(stateKey) {
    this.setState({
      [stateKey]: !this.state[stateKey],
    });
  }

  render() {
    return (
      <>
        <div className="hr-mb-32">
          <CollapsibleForm
            title="Dietary Needs"
            text={this.state.dietaryPrefsText || 'Set your preferences.'}
            iconDesktop={`/public/img/preferences/dietary_icon.svg`}
            contentVisible={this.state.dietaryPreferencesFormVisible}
            toggleForm={() => this.toggleForm('dietaryPreferencesFormVisible')}
            dataCy={'dietary-needs'}
          >
            <DietaryNeeds
              testid="food-profile-dietary-needs-exp-99"
              onSubtextChange={this.createDisplayedText}
            />
          </CollapsibleForm>
        </div>
        <div className="hr-mb-32">
          <TagsSections />
        </div>
      </>
    );
  }
}

export default FoodProfile;
